import React, { useEffect } from 'react'
import { useAuthState } from '.'
import { useLocation, useNavigate } from 'react-router-dom'
import { USER_LOGIN_REDIRECT } from '../../utils/constants'
import NoAccess from '../../pages/NoAccess'
import PermissionsIssue from '../../pages/NoAccess/PermissionsIssue'
const RequireAuth = ({
  dashboardAccess,
  roles = ['Basic', 'Power User', 'Admin'],
  env = ['local', 'dev', 'stage', 'prod'],
  children,
}) => {
  const { isAuthenticated, user } = useAuthState()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      window.localStorage.setItem(
        USER_LOGIN_REDIRECT,
        JSON.stringify({ location })
      )
      navigate('/')
    }
  }, [])

  if (isAuthenticated) {
    const isAuthorized = roles.includes(user.role)
    const isAllowedInEnv = env.includes(process.env.REACT_APP_ENV.toLowerCase())
    const access = user.usercomponents.includes(dashboardAccess)
    if (isAuthorized && isAllowedInEnv) {
      if (!access) 
        {
          return <PermissionsIssue />
        }
      return <>{children}</>
    }
    return <NoAccess />
  }

  return null
}

export default RequireAuth
